<div *svgFrontendsLet="inputFormControl.statusChanges | async as status" class="mac-wrapper">
	<svg-frontends-loading *ngIf="status === FORM_STATUS.PENDING" [isSmall]="true" [withBackdrop]="true"></svg-frontends-loading>

	<div [ngClass]="{ 'clr-form-control-disabled': disableControl || formControl.disabled }" class="clr-form-control mac-form-control">
		<label *ngIf="label" [for]="id" class="clr-control-label">
			<svg-frontends-string-or-template-ref [value]="label"></svg-frontends-string-or-template-ref>
			<svg-frontends-required-marker *ngIf="formControl | isFormControlRequired"></svg-frontends-required-marker>
		</label>

		<div
			[ngClass]="{ 'clr-error': inputFormControl.invalid && inputFormControl.touched }"
			class="clr-control-container"
			*svgFrontendsLet="editingIndex$ | async as editingIndex"
		>
			<div class="clr-input-wrapper list-form-input-wrapper">
				<input
					[formControl]="inputFormControl"
					[id]="id"
					[svgFrontendsDisableControl]="disableControl || formControl.disabled"
					[name]="id"
					[placeholder]="placeholder"
					[type]="type"
					[readOnly]="readOnly"
					(paste)="onPaste($event)"
					(keyup.enter)="addItem()"
					class="clr-input mac-input"
				/>
				<cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
				<button
					[disabled]="disableControl || formControl.disabled"
					(click)="addItem()"
					type="button"
					class="btn btn-icon list-form-icon-button"
					[title]="!!editingIndex ? 'Änderungen speichern' : 'Element hinzufügen'"
				>
					<cds-icon *ngIf="editingIndex === null" shape="plus-circle"></cds-icon>
					<cds-icon *ngIf="editingIndex !== null" shape="check"></cds-icon>
				</button>
			</div>

			<div class="clr-subtext-wrapper mac-subtext-wrapper">
				<span *ngIf="helperText && !(inputFormControl.invalid && inputFormControl.touched)" class="clr-subtext">
					<svg-frontends-string-or-template-ref [value]="helperText"></svg-frontends-string-or-template-ref>
				</span>
				<span *ngIf="inputFormControl.invalid && inputFormControl.touched" class="clr-subtext">
					{{ inputFormControl.errors | firstControlError | controlErrorMessage }}
				</span>
				<span
					*ngIf="(!inputFormControl.invalid || !inputFormControl.touched) && formControl.invalid && formControl.touched"
					class="clr-subtext"
				>
					{{ formControl.errors | firstControlError | controlErrorMessage }}
				</span>
			</div>

			<div class="list-form-items" *svgFrontendsLet="items$ | async as items">
				<div *ngIf="items?.length" class="items-wrapper">
					<div *ngFor="let item of items; let i = index" class="list-item" [ngClass]="{ editing: editingIndex === i }">
						<span class="list-item-text">{{ item }}</span>
						<div *ngIf="!disableControl" class="list-item-actions">
							<button
								type="button"
								[disabled]="disableControl || formControl.disabled"
								(click)="editItem(i)"
								class="btn btn-icon list-form-icon-button"
								title="Bearbeiten"
								[attr.aria-label]="'Bearbeiten: ' + item"
							>
								<cds-icon shape="pencil"></cds-icon>
							</button>
							<button
								type="button"
								[disabled]="disableControl || formControl.disabled"
								(click)="removeItem(i)"
								class="btn btn-icon list-form-icon-button"
								title="Löschen"
								[attr.aria-label]="'Löschen: ' + item"
							>
								<cds-icon shape="trash"></cds-icon>
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="!items?.length" class="items-empty-state">
					<span class="empty-message">Noch keine Elemente hinzugefügt</span>
				</div>
			</div>
		</div>
	</div>
</div>
